import { Typography, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import { CardItem } from '../../types/common';
import TemplateCard from './TemplateCard';

interface ITemplatesCardListProps {
  cards: CardItem[];
}

const TemplatesCardList: React.FC<ITemplatesCardListProps> = ({ cards }) => {
  const theme = useTheme();
  return (
    <Stack
      direction={'row'}
      gap={'20px'}
      flexWrap={'wrap'}
      display="grid"
      gridTemplateColumns={{
        mobile: '1fr',
        tablet: '1fr 1fr',
        laptop: 'repeat(3, 1fr)',
        desktop: 'repeat(4, 1fr)',
      }}
    >
      {cards.length > 0 ? (
        cards.map((card) => <TemplateCard key={card.id} {...card} />)
      ) : (
        <Typography
          variant={'h3'}
          sx={{
            margin: '40px auto 0',
            color: theme.custom.palette.primary.lightgray,
            gridColumn: '1/-1',
          }}
        >
          Скоро тут будут варианты
        </Typography>
      )}
    </Stack>
  );
};

export default TemplatesCardList;
